import { useEffect, useRef, useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

function typedToDataUrl(name) {
  const c = document.createElement("canvas");
  c.width = 520; c.height = 140;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.fillStyle = "#1A1A1A";
  ctx.font = "italic 54px 'Segoe Script', 'Brush Script MT', cursive";
  ctx.textBaseline = "middle";
  ctx.fillText(name, 24, 76);
  return c.toDataURL("image/png");
}

export default function SignaturePad({ onChange, testid = "sig" }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [mode, setMode] = useState("draw");
  const [typed, setTyped] = useState("");
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    if (mode === "type") onChange(typed.trim() ? typedToDataUrl(typed.trim()) : null);
  }, [typed, mode]); // eslint-disable-line react-hooks/exhaustive-deps

  const ctx2d = () => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.strokeStyle = "#1A1A1A";
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    return ctx;
  };
  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const start = (e) => { drawing.current = true; const [x, y] = pos(e); ctx2d().beginPath(); ctx2d().moveTo(x, y); e.preventDefault(); };
  const move = (e) => { if (!drawing.current) return; const [x, y] = pos(e); const c = ctx2d(); c.lineTo(x, y); c.stroke(); setDirty(true); };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (dirty) onChange(canvasRef.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setDirty(false);
    onChange(null);
  };

  return (
    <div className="space-y-3" data-testid={`${testid}-wrap`}>
      <div className="flex gap-2">
        <Button type="button" size="sm" variant={mode === "draw" ? "default" : "outline"} data-testid={`${testid}-mode-draw`}
          onClick={() => { setMode("draw"); onChange(null); }}>Draw</Button>
        <Button type="button" size="sm" variant={mode === "type" ? "default" : "outline"} data-testid={`${testid}-mode-type`}
          onClick={() => setMode("type")}>Type</Button>
      </div>
      {mode === "draw" ? (
        <div>
          <canvas ref={canvasRef} width={560} height={160}
            className="w-full h-40 bg-white rounded-md border border-border touch-none cursor-crosshair"
            data-testid={`${testid}-canvas`}
            onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} />
          <div className="flex justify-between items-center mt-1.5">
            <p className="text-xs text-muted-foreground">Sign inside the box with your finger or mouse</p>
            <Button type="button" size="sm" variant="ghost" onClick={clear} data-testid={`${testid}-clear`}>Clear</Button>
          </div>
        </div>
      ) : (
        <div className="space-y-1.5">
          <Label className="text-xs">Type your signature</Label>
          <Input value={typed} onChange={(e) => setTyped(e.target.value)} data-testid={`${testid}-typed`}
            placeholder="Your signature" className="italic text-lg" />
          {typed.trim() && (
            <div className="bg-white rounded-md border border-border p-3">
              <img src={typedToDataUrl(typed.trim())} alt="Typed signature preview" className="h-16" data-testid={`${testid}-typed-preview`} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
